import { AfterViewInit, Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { yearsPerRow } from '@angular/material/datepicker';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
// import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { NormativaRiferimentoView } from 'src/app/model/normativa-riferimento-view';
import { AttachmentsService } from 'src/app/services/attachments/attachments.service';

@Component({
  selector: 'app-norma-riferimento',
  templateUrl: './norma-riferimento.component.html',
  styleUrls: ['./norma-riferimento.component.scss']
})
export class NormaRiferimentoComponent implements OnInit, AfterViewInit {
  constructor(private attachmentsService: AttachmentsService) { 
    this.dataSource = new MatTableDataSource();
  }
  // dataSource: MatTableDataSource<NormativaRiferimentoView>;
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = [
		"data",
		"descrizione",
		"azioni",
	];
  totalItems: number = 0;
	pageSize: number = 10; // Imposta la dimensione della pagina iniziale
	pageSizeOptions: number[] = [5, 10, 25, 100]; // Opzioni di dimensione pagina
  pageIndex = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
	currentPage: number;
  
  public ngAfterViewInit(): void {
    this.currentPage = 0;
		this.pageSize = 10;
	}

  public onPageChange(event: PageEvent) {
		this.currentPage = event.pageIndex;
		this.loadDatatable();
	}
  
  ngOnInit(): void {
    this.loadDatatable();
  }

  loadDatatable () {
      this.attachmentsService.ricercaNormative(this.pageIndex, this.pageSize).subscribe({
      next: (response: any) => {
        this.totalItems = response.result.count;
        for (let i = 0; i < this.totalItems - 1; i++) {
          let strCamelCase = response.result.listaNormative[i].descrizione.charAt(0).toUpperCase() + response.result.listaNormative[i].descrizione.substr(1).toLowerCase();
          response.result.listaNormative[i].descrizione = strCamelCase;
        }
        // this.dataSource = new MatTableDataSource<NormativaRiferimentoView>(response.result.listaNormative);
        this.dataSource = new MatTableDataSource(response.result.listaNormative);
        this.dataSource.sort = this.sort;
      }
    })
  }

  downloadNormativa(id:any) {
    let data = {
      valore:id
    }
    this.attachmentsService.downloadDocumentoHomePage(data).subscribe( 
      (data:any) => {
        let fileName: string = "NormativaRiferimento.pdf";
        this.attachmentsService.downloadService(data, fileName);
      }
    )
  }

  onPaginateChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadDatatable();
  }
}